import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "br-wrapper d-flex flex-wrap align-items-center justify-content-between pb-60 br-2" }
const _hoisted_2 = { class: "text-title fs-30 mb-0 fw-black" }
const _hoisted_3 = { class: "breadcrumb-menu list-style" }
const _hoisted_4 = { class: "fs-14" }
const _hoisted_5 = { class: "fs-14 active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/landing-page" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Home ")
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _createElementVNode("li", _hoisted_5, _toDisplayString(_ctx.pageTitle), 1)
    ])
  ]))
}